import { createSlice } from "@reduxjs/toolkit";
import { articleGet } from "reduxStore/actions/articles";


const initialState = {
  userLoading: false,
  article: [],
  error: null,
};

const articleSlice = createSlice({
  name: 'article',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(articleGet.fulfilled, (state, action) => {
        state.article = action.payload;

        state.userLoading = false;
      })
      .addCase(articleGet.pending, (state) => {
        state.userLoading = true;
      })
      .addCase(articleGet.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      });
  },
});

export default articleSlice.reducer;

